import { css } from '@emotion/react';
import React from 'react';

import Divider from '@/src/shared/components/Divider';
import { colors } from '@/styles';

const styles = {
  stickyFooterContainer: css`
    position: sticky;
    bottom: 0;
    padding-bottom: 2.6rem;
    background-color: ${colors.white};
    z-index: 2;
  `,
};

function StickyFooter({ children }) {
  return (
    <div css={styles.stickyFooterContainer}>
      <Divider />
      {children}
    </div>
  );
}

export default StickyFooter;
